"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const utils_page_get_time_hash_1 = require("@gcloud-npm/utils.page.get-time-hash");
const utils_common_is_front_app_1 = __importDefault(require("@gcloud-npm/utils.common.is-front-app"));
let instance = null;
class VarBox extends react_1.Component {
    static initialize() {
        if (!instance) {
            instance = new VarBox();
            instance.time = (0, utils_page_get_time_hash_1.getTimehash)();
        }
    }
    static getTimeHash() {
        VarBox.initialize();
        if ((0, utils_common_is_front_app_1.default)()) {
            const timeHashMeta = document.querySelector('meta[id="var-box-time-hash"]');
            if (timeHashMeta) {
                return timeHashMeta.getAttribute("content");
            }
            return "";
        }
        return instance.time;
    }
    render() {
        VarBox.initialize();
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("meta", { id: "var-box-time-hash", content: VarBox.getTimeHash() })));
    }
}
exports.default = VarBox;
//# sourceMappingURL=index.js.map